<template>
  <v-toolbar
    app
    fixed
    clipped-left
    height='88'
    dark
    :color=" backgroundColor || 'primary'"
    :style="{ backgroundImage: `url(${headerBackgroundImage})`}">
    <v-layout wrap align-center justify-center>
      <v-flex xs2 sm2 md4 lg3 xl2 class="toolbar-item">
        <v-layout row align-center align-content-center justify-center>
          <v-flex d-flex>
            <v-avatar size='5.2rem'>
              <img src='../assets/singha.png' alt='#'>
            </v-avatar>
          </v-flex>
          <v-flex hidden-sm-and-down>
            <v-flex subheading>
              สำนักบริหารการทะเบียน
            </v-flex>
            <v-flex subheading>
              กรมการปกครอง
            </v-flex>
            <v-flex caption class="ellipsis-overflow-text">
              The Bureau Of Registration Administration
            </v-flex>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md4 lg6 xl8  text-xs-left text-md-center class="toolbar-item">
        <v-flex title>
          {{ systemName }}
        </v-flex>
        <v-flex subheading mt-2>
          {{ programName }}
        </v-flex>
      </v-flex>
      <v-flex md4 lg3 xl2 text-md-right hidden-sm-and-down pr-2 class="toolbar-item">
        <v-flex subheading class="ellipsis-overflow-text">
          {{ workPlace }}
        </v-flex>
        <v-flex caption class="ellipsis-overflow-text" v-if="officerName">
          นายทะเบียน: {{ officerName }}
        </v-flex>
        <v-flex caption class="ellipsis-overflow-text">
          ผู้ปฏิบัติงาน: {{ clerkName }}
        </v-flex>
        <v-flex caption mt-1>
          <span v-if="systemDate">{{ systemDate }} </span>
          <span v-if="time">{{ time }} น.</span>
          <span v-if="version" class="ml-2">v.{{ version }}</span>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-toolbar>
</template>

<script>
import moment from 'moment'
import headerBackgroundImage from '../assets/bg_header.png'

export default {
  name: 'Header',
  props: [
    'noFixedHeader',
    'placeName',
    'systemName',
    'programName',
    'clerkName',
    'officerName',
    'workPlace',
    'version',
    'backgroundColor',
  ],
  data () {
    return {
      headerBackgroundImage,
      time: null,
      systemDate:"",
    }
  },
  async created () {
    setInterval(_ => {
      this.time = moment().format('HH:mm:ss')
    }, 1000)
    var newDate = new Date()
    var options = {year: 'numeric',month: 'long',day: 'numeric'}
    this.systemDate = newDate.toLocaleString('th-TH',options)
  }
}
</script>

<style scoped>
#maintoolbar .v-toolbar__content {
  padding: 0 0 !important;
}
#maintoolbar .v-toolbar {
  position: relative;
}
.v-toolbar {
  background-repeat: repeat-x;
}
.ellipsis-overflow-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
